import IInitialState from './models';
import { InitialMainReducer } from '../main/main.reducer';
import { InitialAuthReducer } from '../pages/login/auth.reducer';
import { InitialSettingsReducer } from '../pages/settings/settings.reducer';
import { InitialClientsReducer } from '../pages/clients/clients.reducer';
import { InitialPartnersReducer } from '../pages/partners/partners.reducer';
import { InitialTemplatesReducer } from '../pages/templates/reducers';
import { InitialSurveyResultsReducer } from '../pages/results/reducers';

const InitialState: IInitialState = {
	main: InitialMainReducer,
	auth: InitialAuthReducer,
	settings: InitialSettingsReducer,
	clients: InitialClientsReducer,
	partners: InitialPartnersReducer,
	templates: InitialTemplatesReducer,
	results: InitialSurveyResultsReducer,
};

export default InitialState;
